import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  List,
  ListItem,
  ListItemText
} from '@mui/material';

const ActionDialog = ({
  open,
  onClose,
  actionType,
  selectedItems,
  activeTab,
  inviteMessage,
  onInviteMessageChange,
  onExecute
}) => {
  const getDialogTitle = () => {
    switch (actionType) {
      case 'consortium': return 'Add to Consortium';
      case 'suggest': return 'Suggest Funding Calls';
      case 'invite': return 'Invite to Platform';
      default: return '';
    }
  };

  const getDialogContent = () => {
    const itemType = activeTab === 0 ? 'users' : 'organizations';
    const count = selectedItems.length;

    switch (actionType) {
      case 'consortium':
        return `Add ${count} selected ${itemType} to a consortium`;
      case 'suggest':
        return `Suggest relevant funding calls to ${count} selected ${itemType}`;
      case 'invite':
        return `Invite ${count} selected ${itemType} to join the platform`;
      default:
        return '';
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{getDialogTitle()}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          {getDialogContent()}
        </Typography>
        
        {selectedItems.length > 0 && (
          <List dense>
            {selectedItems.slice(0, 5).map((item) => (
              <ListItem key={item.id}>
                <ListItemText
                  primary={
                    activeTab === 0 
                      ? `${item.first_name} ${item.last_name}`
                      : item.name
                  }
                  secondary={
                    activeTab === 0 
                      ? item.email
                      : item.type
                  }
                />
              </ListItem>
            ))}
            {selectedItems.length > 5 && (
              <ListItem>
                <ListItemText 
                  primary={`...and ${selectedItems.length - 5} more`}
                />
              </ListItem>
            )}
          </List>
        )}

        {actionType === 'invite' && (
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Invitation Message"
            value={inviteMessage}
            onChange={(e) => onInviteMessageChange(e.target.value)}
            placeholder="Enter a personalized invitation message..."
            sx={{ mt: 2 }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          variant="contained" 
          onClick={onExecute}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActionDialog;
